<template>
  <div
    v-if="display && showComponent"
    :title="qaAble ? showIfHasPermission?.toString() : null"
    :key="componentRefresh"
  >
  
    <div style="display:flex;flex-direction:column">

      <input
        :id="`inputFieldFile${_uid}`"
        type="file"
        :disabled="disabled||!enableComponent"
        multiple
        style="display: none;"
      >

      <template v-if="!editing">
        <div :id="`inputFileDrag${_uid}`" class="file-drag-container">
          <small>Upload a new file from your system.</small>
          <br>
          <small>Drop file(s) here.</small>
          <br>
          <small>or</small>
          <br>
          <small>
            <a href="" @click.prevent="click"> <i class="fas fa-cloud-upload-alt"></i> Choose files </a>
          </small>
          <br>
          <small v-if="previewFiles.length > 0"> Added Files {{ previewFiles.length }}</small>
        </div>
      </template>

      <template v-else>
        <ks-flex v-if="previewFiles.length > 0" justify="center">
          <ks-button 
            color="link" 
            classIcon="fas fa-arrow-left" 
            @onClick="editFile(selectedFile.index - 1)"
            :disabled="selectedFile.index === 0"
          />
          <ks-space/>
          {{ selectedFile.index + 1 }} of {{ previewFiles.length }}
          <ks-space/>
          <ks-button 
            color="link" 
            classIcon="fas fa-arrow-right" 
            @onClick="editFile(selectedFile.index + 1)"
            :disabled="selectedFile.index === previewFiles.length - 1"
          />
        </ks-flex>

        <div class="input-group">
          <input type="text" class="form-control" placeholder="File Name" v-model="fileNameInput">
        </div>

        <template v-if="enableCropper(selectedFile.name)">
          <ks-image-cropper
            :src="selectedFile.src"
            :fileName="selectedFile.name"
            @crop="crop"
            @reset="crop"
          />
        </template>
        <template v-else>
          <iframe 
            :src="selectedFile._source" 
            border="none"
            style="width:100%; height:100%"
          />
        </template>
      </template>

      <template v-if="previewFiles.length > 0">

        <div style="display: flex;flex-direction:column">
          <ks-text text="File(s) to upload preview:" />

          <div class="file-mosaic">
            <div class="file-mosaic-item" v-for="(file, idx) in previewFiles">
              <div class="options">
                <a style="color: blue;" class="button" @click.prevent="editFile(idx)"><i class="fa fa-edit" aria-hidden="true"></i> </a>
                <a style="color: red;" class="button" @click.prevent="removeFile(idx)"><i class="fa fa-trash" aria-hidden="true"></i></a>
              </div>
              <img :src="file.src" @click="editFile(idx)"/>
            </div>
          </div>
          
          <div style="display:flex; flex-direction:column" v-if="uploadErrors.length > 0">
            <span v-for="error in uploadErrors" class="text-danger">{{ error }}</span>
          </div>

          <div style="display: flex;">
            <ks-button
              v-show="!uploadLoading"
              @onClick="upload"
              :label="`Upload ${previewFiles.length > 1 ? '(all)':''}`"
              classIcon="fa fa-upload"
            />
            <ks-button
              v-show="uploadLoading"
              :disabled="true"
              :label="`Upload ${previewFiles.length > 1 ? '(all)':''}`"
              classIcon="fas fa-spinner fa-pulse"
            />

            <ks-button
              v-if="editing"
              class="ml-2"
              color="secondary"
              @onClick="closeEdit"
              label="Close Edit"
              classIcon="fa fa-times"
            />
            <ks-button
              v-else
              class="ml-2"
              color="danger"
              @onClick="cancel"
              label="Cancel"
              classIcon="fa fa-ban"
            />
          </div>
        </div>

      </template>

    </div>
  </div>
</template>
<script>
import checkPermissions from '../../mixins/checkPermissions';
import fileTypeIs from '../../mixins/fileTypeIs';

export default {
  name: 'input-file',
  mixins: [checkPermissions, fileTypeIs],
  props: {
    multiple:{
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    display: {
      type: Boolean,
      default: true
    },
    maxSizeFile: {
      type: Number, //MB
      default: null
    },
    uploadOptions:{
      type: Object,
      required: true
    }
  },
  watch: {
    fileNameInput(newVal) {
      if(this.timeout){
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        const dt = new DataTransfer();
        for(let i = 0; i < this.files.length; i++){
          if(i==this.selectedFile.index) dt.items.add(new File([this.files[this.selectedFile.index]], newVal, {type: this.selectedFile.type})); 
          else dt.items.add(this.files[i]);
        }
        this.files = dt.files;
      }, 1500);
    }
  },
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    dataProviderName() {
      return this.$parent.dataProvider;
    },
    dataProvider() {
      return this.$parent.data_provider_ref;
    },
    computedValidationStatus() {
      return this.isValid === null ? "none" : this.isValid === true ? "" : "is-invalid"; /*is-valid*/
    },
    previewFiles() {
      let fileArray = Array.from(this.files);
      fileArray.map((file, index) => {
        let fileExtension = file.name?.split(".").pop();
        if (fileExtension == 'pdf') {
          file.src = require("../../assets/images/pdf.jpeg");
          file["_source"] = window.URL.createObjectURL(file);
        } else if (this.fileTypeIs('audio', fileExtension)) {
          file.src = require("../../assets/images/audio.png");
          file["_source"] = window.URL.createObjectURL(file);
        } else if (this.fileTypeIs('video', fileExtension)) {
          file.src = require("../../assets/images/video.jpg");
          file["_source"] = window.URL.createObjectURL(file);
        } else {
          file.src = window.URL.createObjectURL(file);
        }
        file.width = 105;
        file.height = 105;
        file["className"] = 'input-preview-file-img';
        file["index"] = index;
      })
      return fileArray;      
    }
  },
  mounted() {
    this.init();
    this.$emit('onMounted', this);
  },
  methods: {
    
    init() {
      this.fileselect = document.getElementById(`inputFieldFile${this._uid}`);
      this.fileselect.addEventListener("change", this.fileSelectHandler, false);

      this.filedrag = document.getElementById(`inputFileDrag${this._uid}`);
      this.filedrag.addEventListener("dragover", this.fileDragHover, false);
      this.filedrag.addEventListener("dragleave", this.fileDragHover, false);
      this.filedrag.addEventListener("drop", this.fileSelectHandler, false);
    },

    fileDragHover(e) {
      e.stopPropagation();
      e.preventDefault();
      if (e.type == "dragover") {
        e.target.classList.add("file-drag-container-dragover");
      } else {
        e.target.classList.remove("file-drag-container-dragover");
      }
    },

    fileSelectHandler(e) {
      this.fileDragHover(e);
      let files = e.target.files || e.dataTransfer.files;
      console.log(files);
      if (files && files.length > 0) {
        const lastIndex = this.previewFiles.length == 0 ? 0 : this.previewFiles.length;
        this.mergeFiles(files);
        this.fileselect.value = '';
        this.editFile(lastIndex);
        this.$emit('onChange', this);
      }
    },
    
    mergeFiles(files){
      let aux = Array.from(files);
      if (this.maxSizeFile != null && this.maxSizeFile > 0) {
        aux = aux.filter(file => (this.maxSizeFile * 1048576) > file.size);
      }
      let concatLists = [...Array.from(this.files), ...aux];
      const uniqueFiles = Array.from(new Set(concatLists.map(file => file.name))).map(name => concatLists.find(file => file.name === name));
      const dataTransfer = new DataTransfer();
      uniqueFiles.forEach(file => dataTransfer.items.add(file));
      this.files = dataTransfer.files;
    },

    removeFile(index) {
      const dt = new DataTransfer();
      for(let i = 0; i < this.files.length; i++){
        if(i!==index){ dt.items.add(this.files[i])}
      }
      this.files = dt.files;
      if(this.selectedFile){
        if(this.selectedFile.index == index){
          if(this.previewFiles.length > 0 ) this.selectedFile = this.previewFiles[0];
          else this.cancel();
        }else if(this.selectedFile.index !== 0){
          this.selectedFile.index = index-1;
        }
      }
      this.$emit('onRemoveFile', this);
    },

    editFile(index) {
      this.selectedFile = this.previewFiles[index];
      this.fileNameInput = this.selectedFile.name;
      this.editing = true;
      this.$emit('onOpenEdit', this);
    },

    crop(file) {
      const dt = new DataTransfer();
      for(let i = 0; i < this.files.length; i++){
        if(i==this.selectedFile.index) dt.items.add(file); 
        else dt.items.add(this.files[i]);
      }
      this.files = dt.files;
    },

    click() {
      this.fileselect.click();
      this.$emit('onClick', this);
    },

    cancel() {
      let dt = new DataTransfer();
      this.editing = false;
      this.files = dt.files;
      this.fileselect.value = '';
      this.uploadErrors = [];
      this.selectedFile = null;
      this.$emit('onCancel', this);
    },

    closeEdit(){
      this.editing = false;
      this.selectedFile = null;
      this.$emit('onCloseEdit', this);
    },

    enableCropper(fileName) {
      if (!fileName) return false;
      let fileExtension = fileName.split(".").pop();
      return this.fileTypeIs('image', fileExtension);
    },

    async upload(){
      this.uploadLoading = true;
      this.uploadErrors = [];
      try{
        const result = await app.data.create("file.file", this.uploadOptions, this.files);
        app.toast("Files Uploaded Successfully", "success");
        this.$emit('onUpload', {ref:this, result: result});
        this.cancel();
        this.uploadLoading = false;
      }catch(err){
        if(Array.isArray(err))this.uploadErrors = err.map(err => err.error_text);
        else this.uploadErrors = [err];
        app.toast(`Upload Error: ${this.uploadErrors[0]}`, "danger");
        this.$emit('onUploadError', {ref:this, error: err});
        this.uploadLoading = false;
      }
    }

  },
  data() {
    let dt = new DataTransfer();
    return {
      editing: false,
      id: null,
      fileselect: null,
      filedrag: null,
      files: dt.files,
      selectedFile: null,
      imageSrc: null,
      fileNameInput: null,
      timeout: null,
      uploadErrors: [],
      uploadLoading: false
    }
  }
}
</script>

<style>
.file-drag-container {
  min-height: 75px;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  padding: 1em 0;
  margin: 1em 0;
  color: #555;
  border: 2px dashed #555;
  border-radius: 7px;
}

.file-drag-container:hover {
  background: #dadada;
  cursor: grabbing;
}

.file-drag-container-dragover {
  color: #212121;
  border: 2px dashed #0064cc;
  background: #d2d2d2;
}

.input-preview-file-container {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  margin: auto;
}

.input-preview-file {
  flex: 1 1 auto;
  display: inline-block;
  position: relative;
}

.input-preview-file a {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: blue;
  color: #FFF;
}

.input-preview-file-img {
  max-width: 100%;
  max-height: 100%;
  padding: .25rem;
}

.preview-file:hover .input-preview-file-img {
  opacity: 0.2;
  transition: .5s ease;
  background-color: rgba(0, 0, 0, 0.23);
}

.preview-file {
  position: relative;
  float: left;
}

.preview-file .input-delete-file {
  position: absolute;
  top: 0;
  right: 0;
  display: none;
  width: 18px;
  height: 18px;
  font-size: 18px;
  cursor: pointer;
  margin: 5px;
  color: red;
}

.preview-file:hover .input-delete-file {
  display: block;
}

.preview-file .input-edit-file {
  position: absolute;
  top: 0;
  right: 2;
  display: none;
  width: 18px;
  height: 18px;
  font-size: 18px;
  cursor: pointer;
  margin: 5px;
  color: blue;
}

.preview-file:hover .input-edit-file {
  display: block;
}

</style>
